module.exports = __webpack_public_path__ + "media/images/mailer/icon_file_download-0b212ed1bca11e1e02539a20b3821d87.png";